import { put } from 'helpers/api';
import { requestErrors } from 'helpers/api_errors';

export const SAVE_STARTED = 'ALTERNATE_ROYALTY/SAVE_STARTED';
function saveStarted() {
  return {
    type: SAVE_STARTED,
  };
}

export const SAVE_FAILED = 'ALTERNATE_ROYALTY/SAVE_FAILED';
function saveFailed(errors) {
  return {
    type: SAVE_FAILED,
    errors,
  };
}

export const CLEAR_ERRORS = 'ALTERNATE_ROYALTY/CLEAR_ERRORS';
export function clearErrors() {
  return {
    type: CLEAR_ERRORS,
  };
}

export const SET_SETTINGS = 'ALTERNATE_ROYALTY/SET_SETTINGS';
function setSettings(settings) {
  return {
    type: SET_SETTINGS,
    enabled: settings.enabled,
    royaltyPercent: settings.royaltyPercent,
  };
}

export function saveAlternateRoyaltySettings(settings) {
  return (dispatch, getState) => {
    dispatch(saveStarted());

    const { paths } = getState();

    const body = {
      company: {
        alternateRoyaltyEnabled: settings.enabled,
        alternateRoyaltyPercent: settings.royaltyPercent,
      },
    };

    return put(paths.alternateRoyalty, body)
      .then(() => {
        dispatch(setSettings(settings));
      })
      .catch((errors) => {
        dispatch(saveFailed(requestErrors(errors, 'Unable to save alternate royalty settings')));
      });
  };
}
